import React from "react";
import { hot } from "react-hot-loader/root";

import { withAppLayout } from "components/app_layout/AppLayout";
import NoticesAnalysisContent from "components/notice_analysis/NoticeAnalysisContent";
import { MARKET_ANALYSIS, useVariableValue } from "lib/featureFlags";
import { TrackingProvider } from "lib/tracking";

function NoticesAnalysisPage() {
  const isMarketAnalysisEnabled = useVariableValue(MARKET_ANALYSIS, false);
  if (!isMarketAnalysisEnabled) {
    return null;
  }

  return (
    <TrackingProvider data={{ "Page source": "Market Analysis" }}>
      <NoticesAnalysisContent />
    </TrackingProvider>
  );
}

export default hot(
  withAppLayout(NoticesAnalysisPage, {
    pageName: "Notice View Analysis",
  }),
);
